import React, { useState, useEffect, useRef } from "react";
import ReportCount from "../reports/ReportCount";
import FieldOptionValueReport from "../field_options/FieldOptionValueReport";
import ReportsHelpers from "../../utils/ReportsHelpers";
import readReportCount from "../../utils/readReportCount";
import FunnelTrackedMetrics from "../reports/FunnelTrackedMetrics";

const FieldReport = (props) => {
  const element = props.element;
  const field = props.field;
  const idPrefix = props.reportIdPrefix || "";
  const parentField = element.fields.filter(
    (parentField) => parentField.id == field.field_id
  )[0];

  const canShowFieldValues =
    [
      "survey",
      "image",
      "color",
      "emoji",
      "icon",
      "letter",
      "dropdown",
      "select",
      "radio",
      "checkbox",
    ].includes(field.field_type) ||
    (!field.field_type && element.element_type == "quiz");

  const [showFieldValues, setShowFieldValues] = useState(false);
  const questionPosition =
    element.element_type == "quiz"
      ? props.questionNumber != null
        ? props.questionNumber
        : !parentField
        ? field.position
        : `${parentField.position}.${field.position}`
      : null;

  const calculateSelectionRates = (element) => {
    const conversionsSpan = document.getElementById(
      `${idPrefix}field-report-${field.id}`
    );
    const conversions = readReportCount(conversionsSpan);

    $(
      `.element-selection-report[data-field-id="${field.id}"][data-report-id-prefix="${idPrefix}"]`
    ).each((i, elementSelectionReportDiv) => {
      const selectionsSpan = $(elementSelectionReportDiv).find(
        ".events-report-count"
      )[0];
      const conversionRateElement = $(elementSelectionReportDiv).find(
        ".conversion-rate"
      )[0];
      const conversionBarElement = $(elementSelectionReportDiv).find(
        ".element-selection-report-bar"
      )[0];

      const selections = readReportCount(selectionsSpan);
      let conversionRateValue =
        selections > 0 && conversions > 0
          ? (selections / conversions) * 100
          : 0;

      if (conversionRateValue > 100) {
        conversionRateValue = 100.0;
      }

      $(conversionRateElement).text(conversionRateValue.toFixed(2));

      if (conversionRateValue > 0) {
        $(conversionBarElement)
          .css("width", `${conversionRateValue}%`)
          .attr("aria-valuenow", conversionRateValue)
          .show();
      }

      $(elementSelectionReportDiv).css("order", selections);
    });
  };

  return (
    <React.Fragment>
      <div
        className="row hard-center element-selection-report"
        data-element-id={element.id}
        data-report-id-prefix={idPrefix}
        style={{ width: "100%" }}
      >
        <div
          className="element-selection-report-bar"
          style={{ width: 0 }}
        ></div>
        <div
          className="row hard-center funnel-breakdown-item-row"
          style={{
            cursor: canShowFieldValues ? "pointer" : undefined,
          }}
          onClick={
            canShowFieldValues
              ? () => {
                  setShowFieldValues(!showFieldValues);
                }
              : undefined
          }
          onKeyDown={
            canShowFieldValues
              ? (event) => {
                  if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    setShowFieldValues(!showFieldValues);
                  }
                }
              : undefined
          }
          role={canShowFieldValues ? "button" : undefined}
          tabIndex={canShowFieldValues ? 0 : undefined}
          aria-expanded={canShowFieldValues ? showFieldValues : undefined}
        >
          <div className="col-xs-4 funnel-breakdown-question-label">
            <div
              className="text-xl field-report-toggle"
              data-field-id={field.id}
              style={{
                marginBottom: "5px",
                display: "flex",
                alignItems: "center",
              }}
            >
              {questionPosition != null && (
                <span
                  className="funnel-breakdown-question-position"
                  style={{ flexShrink: 0 }}
                >
                  {questionPosition}
                </span>
              )}
              <span
                className="ellipsis funnel-breakdown-question-text"
                style={{ minWidth: 0 }}
              >
                {questionPosition != null ? " - " : ""}
                {ReportsHelpers.fieldReportLabel(field)}
              </span>
              {canShowFieldValues && (
                <span
                  className={`glyphicon glyphicon-chevron-${
                    showFieldValues ? "down" : "right"
                  } element-selection-report-toggle ml-1`}
                  style={{ flexShrink: 0 }}
                ></span>
              )}
            </div>
          </div>
          <div className="col-xs-8 right">
            <p className="light text-xl" style={{ marginBottom: "10px" }}>
              <strong>
                <ReportCount
                  inline={true}
                  id={`${idPrefix}field-report-${field.id}`}
                  path={`/websites/${props.cta.website_id}/events_reports`}
                  payload={{
                    report_type: "distinct_count",
                    report: {
                      website_id: props.cta.website_id,
                      event_type:
                        element.element_type == "quiz"
                          ? "Selection"
                          : "Complete",
                      contactable_type: "Cta",
                      contactable_id: props.cta.id,
                      variant_id: props.step.variant_id,
                      step_id: props.step.id,
                      element_id: element.id,
                      product_id: null,
                      product_variant_id: null,
                      field: field.report_keys,
                      range_start: props.range_start,
                      range_end: props.range_end,
                      broadcast_id: null,
                    },
                  }}
                  callback={() => {
                    props.calculationConversionRates();
                  }}
                />
              </strong>{" "}
              responded (<span className="conversion-rate">0.00</span>%)
              <FunnelTrackedMetrics
                layout="details"
                idBase={`${idPrefix}field-${field.id}`}
                selectionsId={`${idPrefix}field-report-${field.id}`}
                path={`/websites/${props.cta.website_id}/events_reports`}
                currency={props.currency}
                gateReports={props.gateReports}
                reportingGoals={props.reportingGoals}
                report={{
                  website_id: props.cta.website_id,
                  contactable_type: "Cta",
                  contactable_id: props.cta.id,
                  variant_id: props.step.variant_id,
                  step_id: props.step.id,
                  element_id: element.id,
                  range_start: props.range_start,
                  range_end: props.range_end,
                  field: field.report_keys,
                  value: null,
                  product_id: null,
                  product_variant_id: null,
                  broadcast_id: null,
                }}
              />
            </p>
          </div>
        </div>
        {canShowFieldValues && showFieldValues && (
          <div
            className="row hard-center"
            style={{
              display: "flex",
              width: "100%",
              flexBasis: "100%",
              flexWrap: "wrap",
              flexDirection: "column-reverse",
            }}
          >
            {[...(field.field_options || [])]
              .sort((a, b) => (a.position || 0) - (b.position || 0))
              .map((field_option) => {
                return (
                  <FieldOptionValueReport
                    key={`field-option-report-${field_option.id}`}
                    id={`field-option-report-${field_option.id}`}
                    field={field}
                    field_option={field_option}
                    calculateSelectionRates={() => {
                      calculateSelectionRates();
                    }}
                    {...props}
                  />
                );
              })}
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default FieldReport;
